import React from "react";
import classnames from "classnames";
import styles from "./Switch.module.scss";

export interface SwitchProps {
    label: string;
    checked: boolean;
    onChange: (next: boolean) => void;
    /** Пояснение под подписью */
    hint?: string;
    disabled?: boolean;
    className?: string;
}

/**
 * Строка-переключатель «подпись — тумблер» (настройки). Вся строка — одна зона касания
 * не ниже 44 px; состояние передаётся `role="switch"` и `aria-checked`, а не только цветом:
 * у включённого тумблера бегунок справа.
 */
export const Switch = ({ label, checked, onChange, hint, disabled, className }: SwitchProps) => (
    <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        className={classnames(styles.row, { [styles.on]: checked }, className)}
        onClick={() => onChange(!checked)}
    >
        <span className={styles.text}>
            <span className={styles.label}>{label}</span>
            {hint && <span className={styles.hint}>{hint}</span>}
        </span>
        <span className={styles.track} aria-hidden="true">
            <span className={styles.thumb} />
        </span>
    </button>
);
